

import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import Avatar from '@mui/material/Avatar';
import { axiosInstance } from '../../../../lib/axiosInstance';
import styles from './allSessions.module.css';

function AllSessions() {
  const [allSessions, setAllSessions] = useState([]);
  const [myProfileId, setMyProfileId] = useState('');
  const [selectedTab, setSelectedTab] = useState('future');
  const [friendRequestStatus, setFriendRequestStatus] = useState({});

  useEffect(() => {
    async function fetchProfileId() {
      try {
        const profileResponse = await axiosInstance.get('/profile');
        setMyProfileId(profileResponse.data._id);
      } catch (error) {
        console.error('Error fetching profile ID:', error);
      }
    }
    fetchProfileId();
  }, []);

  useEffect(() => {
    async function fetchSessions() {
      try {
        const response = await axiosInstance.get('/sessions/mine');
        const sessions = response.data;

        // Attach partner info
        const updatedSessions = await Promise.all(
          sessions.map(async (s) => {
            let partnerName = 'Matching...';
            let partnerId = '';
            if (s.isPaired) {
              partnerId = (myProfileId === s.createdBy) ? s.pairedWith : s.createdBy;
              try {
                const partnerResponse = await axiosInstance.get(`/profile/?userID=${partnerId}`);
                partnerName = partnerResponse.data.name;
              } catch (error) {
                console.error('Error fetching partner info:', error);
              }
            }
            return { ...s, partnerName, partnerId };
          })
        );
        setAllSessions(updatedSessions);
      } catch (error) {
        console.error('Error fetching sessions:', error);
      }
    }

    if (myProfileId) {
      fetchSessions();
    }
  }, [myProfileId]);

  const currentTime = dayjs();
  const pastSessions = allSessions
    .filter((session) => dayjs(session.time).isBefore(currentTime))
    .sort((a, b) => dayjs(b.time).diff(dayjs(a.time)));

  const futureSessions = allSessions
    .filter((session) => dayjs(session.time).isAfter(currentTime))
    .sort((a, b) => dayjs(a.time).diff(dayjs(b.time)));

  const handleTabClick = (tab) => setSelectedTab(tab);

  async function sendFriendRequest(partnerId) {
    if (!partnerId) return;
    try {
      await axiosInstance.post('/friends/requests', { userId: partnerId });
      setFriendRequestStatus((prev) => ({
        ...prev,
        [partnerId]: 'Request sent',
      }));
    } catch (error) {
      console.error('Error sending friend request:', error);
      setFriendRequestStatus((prev) => ({
        ...prev,
        [partnerId]: 'Error sending friend request',
      }));
    }
  }

  return (
    <div className={styles.allSessionsContainer}>
      <div className={styles.tabsContainer}>
        <button
          onClick={() => handleTabClick('past')}
          className={`${styles.tabButton} ${selectedTab === 'past' ? styles.activeTab : ''}`}
        >
          Past
        </button>
        <button
          onClick={() => handleTabClick('future')}
          className={`${styles.tabButton} ${selectedTab === 'future' ? styles.activeTab : ''}`}
        >
          Future
        </button>
      </div>

      <div className={styles.sessionsList}>
        {(selectedTab === 'past' ? pastSessions : futureSessions).map((session) => {
          const formattedTime = dayjs(session.time).format('hh:mm A, ddd MMM D');
          const status = friendRequestStatus[session.partnerId] || '';
          return (
            <div className={styles.sessionCard} key={session._id}>
              <div className={styles.person_details_div}>
                <Avatar
                  className={styles.avatar_class}
                  alt={session.partnerName}
                  src={
                    session.isPaired
                      ? `${process.env.REACT_APP_BASE_URL}/api/profile/image?userID=${session.partnerId}&type=profile`
                      : 'images/blank_profile_picture.webp'
                  }
                />
                <p className={styles.person_name_class}>{session.partnerName}</p>
              </div>
              <p className={styles.details}>{session.subject}</p>
              <p className={styles.details}>{session.topic}</p>
              <p className={styles.details}>
                {session.type === 'Discuss and learn with partner' ? 'Discuss and learn' : 'Silent study'}
              </p>
              <p className={styles.details}>{formattedTime}</p>

              {/* Friend request button */}
              {!status || status === 'Error sending friend request' ? (
                <button
                  className={styles.friendRequestButton}
                  onClick={() => sendFriendRequest(session.partnerId)}
                >
                  Send friend request
                </button>
              ) : (
                <button className={styles.friendRequestDoneButton} disabled>
                  {status}
                </button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default AllSessions;














